import { BalanceCreditInfoApiResponse } from 'src/types/Balance';

/**
 * Determines whether a Balance account is on net terms.
 *
 * Net terms:
 * - The account can place orders now and pay invoices later (based on terms).
 * - In this integration, `creditLimit` is a positive number.
 *
 * On-the-spot payments:
 * - The account pays at checkout (no invoice terms).
 * - In this integration, `creditLimit` is `0` or `null`.
 *
 */
export const isBalanceAccountOnNetTerms = (
  creditInfo: BalanceCreditInfoApiResponse | null
): boolean | null => (creditInfo ? Boolean(creditInfo.creditLimit) : null);
